module.exports = __webpack_public_path__ + "img/ooredoo.c890cdcd.svg";